import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import logo from '../../assets/images/logo-2.png';
import { IconPhone, IconMail, IconLocation } from '../Icons/Icons';
import '../../assets/css/footer.css';

const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'Services', to: '/services' },
  { label: 'Compliance', to: '/compliance' },
  { label: 'Contact', to: '/contact' },
];

const SERVICE_LINKS = [
  { label: 'Sustainability Certification', to: '/services#iscc-compliance' },
  { label: 'Regulatory Compliance', to: '/compliance#ofgem' },
  { label: 'Carbon & GHG Reporting', to: '/compliance#carbon' },
];

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <span className="footer-logo-badge">
              <img src={logo} alt="Sustainability Advisory Ltd logo" className="footer-logo" />
            </span>
            <p className="footer-tagline">
              Sustainability, certification and regulatory compliance advisory for the renewable
              fuels and low-carbon energy sectors, supporting confident market access in the UK
              and internationally.
            </p>

            <div className="footer-social">
              <a
                href="https://www.linkedin.com"
                className="footer-social-link"
                aria-label="Sustainability Advisory Ltd on LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              {NAV_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              {SERVICE_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="footer-heading">Contact</h4>
            <ul className="footer-contact">
              <li>
                <IconPhone width={16} height={16} />
                <a href="tel:01984624989">01984 624989</a>
              </li>
              <li>
                <IconPhone width={16} height={16} />
                <a href="tel:07530401925">07530 401925</a>
              </li>
              <li>
                <IconMail width={16} height={16} />
                <a href="mailto:eviegarner@sustainabilityadvisors.co.uk">
                  eviegarner@sustainabilityadvisors.co.uk
                </a>
              </li>
              <li>
                <IconLocation width={16} height={16} />
                <span>Higher Ford, Wiveliscombe, Taunton, Somerset, TA4 2RL</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {year} Sustainability Advisory Ltd. All rights reserved.</p>
          <p className="footer-bottom-tags">Independent · Practical · Audit Ready</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
